import { render, staticRenderFns } from "./PortfolioEvolutionChart.vue?vue&type=template&id=56b9c35d&scoped=true&"
import script from "./PortfolioEvolutionChart.vue?vue&type=script&lang=js&"
export * from "./PortfolioEvolutionChart.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioEvolutionChart.vue?vue&type=style&index=0&id=56b9c35d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b9c35d",
  null
  
)

export default component.exports